import { render, staticRenderFns } from "./BeginnerList.vue?vue&type=template&id=2eb12de6&scoped=true"
import script from "./BeginnerList.vue?vue&type=script&lang=js"
export * from "./BeginnerList.vue?vue&type=script&lang=js"
import style0 from "./BeginnerList.vue?vue&type=style&index=0&id=2eb12de6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb12de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb12de6')) {
      api.createRecord('2eb12de6', component.options)
    } else {
      api.reload('2eb12de6', component.options)
    }
    module.hot.accept("./BeginnerList.vue?vue&type=template&id=2eb12de6&scoped=true", function () {
      api.rerender('2eb12de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/BeginnerCourse/components/BeginnerList.vue"
export default component.exports